/*
 * @Author: Ryan
 * @Date: 2025-12-04
 * @Description: 首屏视频播放器的视频数据配置
 */
import { VideoLanguage } from './types';

// 从视频 URL 中提取语言代码 (例如: "heropagevideotranslationen_xxx.mp4" -> "en")
const extractLanguageCode = (url: string): string => {
  const match = url.match(/heropagevideotranslation([a-z]{2})_/);
  if (!match) return 'en';

  const code = match[1];
  return code;
};

// 语言配置
export const LANGUAGE_CONFIG: Record<
  string,
  { name: string; displayName: string; flagPath: string }
> = {
  en: {
    name: 'English',
    displayName: 'ENGLISH',
    flagPath: '/images/country/flag-us.png',
  },
  fr: {
    name: 'French',
    displayName: 'FRENCH',
    flagPath: '/images/country/flag-fr.png',
  },
  de: {
    name: 'German',
    displayName: 'GERMAN',
    flagPath: '/images/country/flag-de.png',
  },
  es: {
    name: 'Spanish',
    displayName: 'SPANISH',
    flagPath: '/images/country/flag-es.png',
  },
  ru: {
    name: 'Russian',
    displayName: 'RUSSIAN',
    flagPath: '/images/country/flag-ru.png',
  },
};

// 视频 URL 和封面配置
const VIDEO_DATA = [
  {
    videoUrl:
      'https://assets.falcocut.ai/landing-page/video-translator/heropagevideotranslationen_1781062244009545728.mp4',
    posterUrl: '/images/heroVideoPlayer/poster-1.png',
  },
  {
    videoUrl:
      'https://assets.falcocut.ai/landing-page/video-translator/heropagevideotranslationfr_1779589501174980608.mp4',
    posterUrl: '/images/heroVideoPlayer/poster-2.jpeg',
  },
  {
    videoUrl:
      'https://assets.falcocut.ai/landing-page/video-translator/heropagevideotranslationde_1779589386636922880.mp4',
    posterUrl: '/images/heroVideoPlayer/poster-2.jpeg',
  },
  {
    videoUrl:
      'https://assets.falcocut.ai/landing-page/video-translator/heropagevideotranslationes_1779589463472377856.mp4',
    posterUrl: '/images/heroVideoPlayer/poster-3.jpeg',
  },
  {
    videoUrl:
      'https://assets.falcocut.ai/landing-page/video-translator/heropagevideotranslationru_1779589583295258624.mp4',
    posterUrl: '/images/heroVideoPlayer/poster-4.jpeg',
  },
];

// 根据视频 URL 自动提取语言代码，构建完整的视频数据
export const HERO_VIDEOS: VideoLanguage[] = VIDEO_DATA.map((data) => {
  const code = extractLanguageCode(data.videoUrl);
  const config = LANGUAGE_CONFIG[code];

  return {
    code,
    name: config?.name || code,
    displayName: config?.displayName || code.toUpperCase(),
    flagPath: config?.flagPath || '/images/country/flag_us.png',
    videoUrl: data.videoUrl,
    posterUrl: data.posterUrl,
  };
});
